import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_374_2982",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 4,
		y: 2,
		width: 16,
		height: 20,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.3077 21.5C5.80898 21.5 5.38302 21.3234 5.02982 20.9702C4.67661 20.617 4.5 20.191 4.5 19.6923V10.3077C4.5 9.80901 4.67661 9.38305 5.02982 9.02985C5.38302 8.67663 5.80898 8.50003 6.3077 8.50003H7.5V6.50003C7.5 5.25133 7.93782 4.18916 8.81345 3.31353C9.6891 2.43789 10.7513 2.00008 12 2.00008C13.2487 2.00008 14.3108 2.43789 15.1865 3.31353C16.0621 4.18916 16.5 5.25133 16.5 6.50003V8.50003H17.6922C18.191 8.50003 18.6169 8.67663 18.9701 9.02985C19.3233 9.38305 19.5 9.80901 19.5 10.3077V19.6923C19.5 20.191 19.3233 20.617 18.9701 20.9702C18.6169 21.3234 18.191 21.5 17.6922 21.5H6.3077ZM6.3077 20H17.6922C17.782 20 17.8557 19.9712 17.9134 19.9135C17.9711 19.8558 18 19.782 18 19.6923V10.3077C18 10.218 17.9711 10.1443 17.9134 10.0866C17.8557 10.0289 17.782 10 17.6922 10H6.3077C6.21795 10 6.14423 10.0289 6.08652 10.0866C6.02882 10.1443 5.99997 10.218 5.99997 10.3077V19.6923C5.99997 19.782 6.02882 19.8558 6.08652 19.9135C6.14423 19.9712 6.21795 20 6.3077 20ZM12 16.75C12.4859 16.75 12.899 16.5798 13.2394 16.2394C13.5798 15.899 13.75 15.4859 13.75 15C13.75 14.5141 13.5798 14.101 13.2394 13.7606C12.899 13.4202 12.4859 13.25 12 13.25C11.5141 13.25 11.1009 13.4202 10.7606 13.7606C10.4202 14.101 10.25 14.5141 10.25 15C10.25 15.4859 10.4202 15.899 10.7606 16.2394C11.1009 16.5798 11.5141 16.75 12 16.75ZM8.99997 8.50003H15V6.50003C15 5.66669 14.7083 4.95836 14.125 4.37503C13.5416 3.79169 12.8333 3.50003 12 3.50003C11.1666 3.50003 10.4583 3.79169 9.87497 4.37503C9.29164 4.95836 8.99997 5.66669 8.99997 6.50003V8.50003Z",
			fill: "#1C1B1F"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_374_2982)",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#333333"
		})
	})]
});
export default SvgLock;
